module.exports = __webpack_public_path__ + "assets/circles.71c29211.svg";